export default {"src":"/_next/static/media/profile-details.73ade4f8.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};